import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetCaseMovementListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    processDateStart: string | undefined
    processDateEnd: string | undefined
    selectedCaseMovementType: CustomSingleSelectModel | undefined
    selectedCase: CustomSingleSelectModel | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetCaseMovementListPagingAndFilterRequest: GetCaseMovementListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    processDateStart: undefined,
    processDateEnd: undefined,
    selectedCaseMovementType: undefined,
    selectedCase: undefined,
    columnFilters: []
}